import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-exist-doc-electronicos",
  templateUrl: "./exist-doc-electronicos.component.html",
  styleUrls: ["./exist-doc-electronicos.component.scss"],
})
export class ExistDocElectronicosComponent implements OnInit {
  constructor() {}
  optionsBodega: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsBodega2: Array<any> = [];
  optionsMotivo: Array<any> = [];
  optionsEstado: Array<any> = [];
  optionsTipDocumento: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsBodegaSalida: Array<any> = [];
  optionsBodegaIngreso: Array<any> = [];
  optionsFormato: Array<any> = [];

  ngOnInit() {
    this.optionsFormato = [
      { value: "1", label: "Formato 1" },
      { value: "2", label: "Formato 2" },
      { value: "3", label: "Formato 3" },
    ];
    this.optionsBodegaSalida = [
      { value: "1", label: "Bodega 1" },
      { value: "2", label: "Bodega 2" },
      { value: "3", label: "Bodega 3" },
    ];

    this.optionsBodegaIngreso = [
      { value: "1", label: "Bodega 1" },
      { value: "2", label: "Bodega 2" },
      { value: "3", label: "Bodega 3" },
    ];

    this.optionsCategoria = [
      { value: "1", label: "Categoria 1" },
      { value: "2", label: "Categoria 2" },
      { value: "3", label: "Categoria 3" },
    ];

    this.optionsFamilia = [
      { value: "1", label: "Familia 1" },
      { value: "2", label: "Familia 2" },
      { value: "3", label: "Familia 3" },
    ];

    this.optionsEstado = [
      { value: "1", label: "Estado 1" },
      { value: "2", label: "Estado 2" },
      { value: "3", label: "Estado 3" },
    ];

    this.optionsTipDocumento = [
      { value: "1", label: "TipDocumento 1" },
      { value: "2", label: "TipDocumento 2" },
      { value: "3", label: "TipDocumento 3" },
    ];

    this.optionsBodega = [
      { value: "1", label: "Bodega 1" },
      { value: "2", label: "Bodega 2" },
      { value: "3", label: "Bodega 3" },
    ];

    this.optionsRubro = [
      { value: "1", label: "Rubro 1" },
      { value: "2", label: "Rubro 2" },
      { value: "3", label: "Rubro 3" },
    ];

    this.optionsBodega2 = [
      { value: "1", label: "Bodega 1" },
      { value: "2", label: "Bodega 2" },
      { value: "3", label: "Bodega 3" },
    ];

    this.optionsMotivo = [
      { value: "1", label: "Motivo 1" },
      { value: "2", label: "Motivo 2" },
      { value: "3", label: "Motivo 3" },
    ];
  }
}
